// extracted by mini-css-extract-plugin
export default {"activeSidebar":"a-z","pageLayout":"b-z","mainContent":"c-z","columnLayout":"d-z","columnLayoutFill":"e-z","columnLayoutLast":"f-z"};